module.exports = __webpack_public_path__ + "static/media/nn-banner-checkout-mrskin.807de263.jpg";